import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 30px 20px;
`;

export const Title = styled.div`
  color: ${(props) => props.theme['color.text.body']};
  font-size: 20px;
  line-height: 30px;
`;

export const EtextHelpLink = styled.a`
  display: inline;
  cursor: pointer;
  text-decoration: underline;
  font-size: 20px;
  line-height: 30px;
  color: ${(props) => props.theme['color.blueDark']};

  & > i {
    color: ${(props) => props.theme['color.text.light']};
    opacity: 0.7;
    font-size: 24px;
    vertical-align: bottom;
    transform: translate3d(0, -0.05em, 0);
    margin: -5px 0 0 2px;
  }
`;